'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import { CTA_SECURITY, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import SecurityData from '../../data/SecurityData';
import ResultCtaBanner from '../ResultCtaBanner';
import { parseUtmParams } from '../../util/Urls';
import usageTracker from '../../lib/usageTracker';
var CTAButton = /*#__PURE__*/memo(function (_ref) {
  var websiteUrl = _ref.websiteUrl;
  var lang = window.I18N_MANUAL_LANG;
  var isEn = lang === 'en';
  var alt = isEn ? '' : '-alt';
  var url = isEn ? CTA_SECURITY : LanguageCTALinks[lang];
  var parsedUtmParams = parseUtmParams();

  var handleClick = function handleClick() {
    var eventKey = isEn ? 'academyCourseClick' : 'freeGuideClick';
    var action = isEn ? 'clicked-free-lesson-link' : 'clicked-get-guide-link';
    usageTracker.log(eventKey, {
      action: action,
      websiteUrl: websiteUrl,
      source: 'security-section'
    });
  };

  return /*#__PURE__*/_jsx(UILink, {
    href: url + "&" + parsedUtmParams,
    external: true,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "results.security.cta.button" + alt
    })
  });
});
export default (function (_ref2) {
  var websiteGrade = _ref2.websiteGrade,
      _ref2$hideCTAs = _ref2.hideCTAs,
      hideCTAs = _ref2$hideCTAs === void 0 ? false : _ref2$hideCTAs;
  var grade = websiteGrade.securityAudit.grade;
  var websiteUrl = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered security-page",
    id: "security",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-wrapper",
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "add-on-ssl"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.SECURITY_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.description"
          })
        }), !hideCTAs && /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "lock",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.security.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {
                websiteUrl: websiteUrl
              })
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "bg-blob",
          children: /*#__PURE__*/_jsx("div", {
            className: "results-section",
            children: /*#__PURE__*/_jsx(ResultSection, {
              results: SecurityData.results,
              websiteGrade: websiteGrade
            })
          })
        })]
      })
    })
  });
});